import React, { memo } from 'react';
import { FormRenderProps } from 'react-final-form';

import { useAppLayoutContextConsumer } from '@occc-app/design-system';

import { getAudienceCreatePageHeaderLinks } from './utils';

import { FormContent } from '../components/FormContent';
import { AudienceFormValues } from '../types';

type AudienceCreateFormRenderComponentProps = Pick<
  FormRenderProps<AudienceFormValues>,
  'handleSubmit'
> & {
  name?: string;
  clearFormField: (fieldName: string) => void;
};

export const AudienceCreateFormRenderComponent = memo(
  ({ handleSubmit, name, clearFormField }: AudienceCreateFormRenderComponentProps) => {
    const links = React.useMemo(() => getAudienceCreatePageHeaderLinks(name ?? ''), [name]);
    useAppLayoutContextConsumer(links);

    return (
      <form onSubmit={handleSubmit}>
        <FormContent clearFormField={clearFormField} />
      </form>
    );
  },
);
